/*
 * @TagDialog.vue.vue  uwb基站配置
 * @Description
 * @Author CC
 * @Date 2025/09/20
 */
/* HTML */
<template>
	<el-dialog :title="dialogForm.title" :visible.sync="dialogForm.dialogFormVisible" :close-on-click-modal="false" custom-class="form-dialog forms-box" v-dialogDrag class="dialog_title" @close="handleDialogClose">
		<el-form label-width="110px" class="condition-form-item" ref="configForm">
			<el-form-item class="row-items-3" label="编号：" prop="did" v-if="configForm.did != null && configForm.did != ''">
				{{configForm.did}}
			</el-form-item>
            <el-form-item class="row-items-3" label="状态：" prop="status" v-if="configForm.status != null && configForm.status != ''">
                {{status[configForm.status]}}
            </el-form-item>
			<el-form-item class="row-items-3" label="MAC：" prop="mac"  v-if="configForm.mac != null && configForm.mac != '' && configForm.mac != '000000000000'">
				{{configForm.mac}}
			</el-form-item>
			<el-form-item class="row-items-3" label="iccid：" prop="iccid" v-if="configForm.iccid != null && configForm.iccid != ''">
				{{configForm.iccid}}
			</el-form-item>
			<el-form-item class="row-items-3" label="imei：" prop="imei" v-if="configForm.imei != null && configForm.imei != '' && configForm.imei.indexOf('000000') == -1">
				{{configForm.imei}}
			</el-form-item>
            <el-form-item class="row-items-3" label="SIM套餐：" prop="simPackage" v-if="configForm.simPackage != null && configForm.simPackage != ''">
                {{configForm.simPackage}}
            </el-form-item>
			<el-form-item class="row-items-3" label="SIM状态：" prop="simStatus" v-if="configForm.simStatus != null && configForm.simStatus != ''">
				{{configForm.simStatus}}
			</el-form-item>
			<el-form-item class="row-items-3" label="已用流量：" prop="simUsed" v-if="configForm.simUsed != null && configForm.simUsed != ''">
				{{configForm.simUsed + ' M'}}
			</el-form-item>
			<el-form-item class="row-items-3" label="激活时间：" prop="simActivationTime" v-if="configForm.simActivationTime != null && configForm.simActivationTime != ''">
				{{configForm.simActivationTime}}
			</el-form-item>
			<el-form-item class="row-items-3" label="过期时间：" prop="simExpirationTime" v-if="configForm.simExpirationTime != null && configForm.simExpirationTime != ''">
				{{$moment(configForm.simExpirationTime).format('YYYY-MM-DD HH:mm:ss')}}
			</el-form-item>
			<el-form-item class="row-items-3" label="软件版本号：" prop="versionSoft" v-if="configForm.versionSoft != null && configForm.versionSoft != ''">
				{{configForm.versionSoft}}
			</el-form-item>
			<el-form-item class="row-items-3" label="硬件版本号：" prop="versionHard" v-if="configForm.versionHard != null && configForm.versionHard != ''">
				{{configForm.versionHard}}
			</el-form-item>
			<el-form-item class="row-items-3" label="电量：" prop="power" v-if="configForm.power != null && configForm.power != ''">
				{{configForm.power + ' %'}}
			</el-form-item>
			<el-form-item class="row-items-3" label="电压：" prop="volt" v-if="configForm.volt != null && configForm.volt != ''">
				{{configForm.volt}}
			</el-form-item>
			<el-form-item class="row-items-3" label="气压：" prop="air" v-if="configForm.air != null && configForm.air != ''">
				{{configForm.air}}
			</el-form-item>
			<el-form-item class="row-items-3" label="版本号：" prop="versionConfig" v-if="configForm.versionConfig != null && configForm.versionConfig != ''">
				{{configForm.versionConfig}}
			</el-form-item>
			<div v-if="configForm.positionMode > 0">
                <el-form-item class="row-items-1" label="最近定位位置：" prop="address">
                    {{configForm.address + "【" + "定位模式：" + positionModes[configForm.positionMode] + " | "  + "定位时间：" + $moment(configForm.uploadTime).format('YYYY-MM-DD HH:mm:ss') + "】 "}}
                </el-form-item>
			</div>
			<div v-if="dialogForm.editState == 0">
				<el-form-item class="row-items-3" label="支持定位模式：" prop="positionModeNames">
					{{Object.assign([], configForm.positionModeNames).join(", ")}}
					<!--{{configForm.positionModeNames.join(", ")}}-->
				</el-form-item>
            <el-form-item class="row-items-3" label="服务器地址：" prop="ips" v-if="configForm.serverIp!=''">
                {{configForm.serverIp}}
            </el-form-item>
            <div v-if="configForm.type != '01' && configForm.type != '02' && configForm.type != '03' && configForm.type != '05'  && configForm.type != 'GT808'">
                <el-form-item class="row-items-3" label="定位类型："  v-if="configForm.statusWorking==17 || configForm.statusWorking==18" >
                    {{statusWorking[configForm.statusWorking]}}
                </el-form-item>
                <el-form-item class="row-items-3" label="普通定位周期：" prop="syncFreq" v-if="configForm.statusWorking==17">
                    {{configForm.syncFreq + ' 秒'}}
                </el-form-item>
                <el-form-item class="row-items-3" label="普通同步周期：" prop="locationModeFreqNormal" v-if="configForm.statusWorking==17">
                    {{configForm.locationModeFreqNormal + ' 秒'}}
                </el-form-item>
                <el-form-item class="row-items-3" label="快速定位周期：" prop="syncFreqFast" v-if="configForm.statusWorking==18">
                    {{configForm.syncFreqFast + ' 秒'}}
                </el-form-item>
                <el-form-item class="row-items-3" label="快速同步周期：" prop="locationModeFreqFast" v-if="configForm.statusWorking==18">
                    {{configForm.locationModeFreqFast + ' 秒'}}
                </el-form-item>
                <el-form-item class="row-items-3" label="保底同步间隔：" prop="locationModeFreqNormalMorning" v-if="configForm.statusWorking==18">
                    {{configForm.locationModeFreqNormalMorning + ' 秒'}}
                </el-form-item>
            </div>
            <div v-else>
                <div v-if="configForm.type != '01' && configForm.type != 'GT808'">
                    <el-form-item class="row-items-1" label="定位配置：" prop="configs" v-if="configForm.configs != null && configForm.configs != ''">
                        <json-viewer :value="configForm.config" :expand-depth="5" copyable boxed sort theme="my-awesome-json-theme"></json-viewer>
                    </el-form-item>
                </div>
            </div>
            <div v-if="configForm.deviceStatus != null && configForm.deviceStatus != ''">
              <el-form-item class="row-items-1" label="设备状态：" prop="address">
                <json-viewer :value="JSON.parse(configForm.deviceStatus)" :expand-depth="15" copyable boxed sort theme="my-awesome-json-theme"></json-viewer>
              </el-form-item>
            </div>
            <div v-if="configForm.lbsData != null && configForm.lbsData != ''">
              <el-form-item class="row-items-1" label="LBS数据：" prop="address">
                <json-viewer :value="JSON.parse(configForm.lbsData)" :expand-depth="15" copyable boxed sort theme="my-awesome-json-theme"></json-viewer>
              </el-form-item>
            </div>
            <div v-if="configForm.configs != null && configForm.configs != '' && configForm.type != '01' ">
                <el-form-item class="row-items-1 btn-form-item-r" style="text-align: center;">
                    <el-button type="primary" size="mini" @click.native="editConfig">编辑配置</el-button>
                </el-form-item>
            </div>
			</div>
			<div v-else>
          <el-form-item class="row-items-1" label="支持定位模式：" prop="positionModeArray">
              <el-select v-model="configForm.positionModeArray" multiple filterable placeholder="请选择定位模式" clearable>
                  <el-option label="GPS" :value="1"></el-option>
                  <el-option label="WIFI" :value="2"></el-option>
                  <el-option label="LBS" :value="3"></el-option>
                  <el-option label="PHONE" :value="5"></el-option>
                  <el-option label="BD" :value="6"></el-option>
                  <el-option label="GN" :value="7"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item class="row-items-3" label="服务器IP：" prop="serverIp">
              <el-select v-model="configForm.serverIp" placeholder="请选择服务器地址">
                  <el-option label="iot.jinkuncloud.com:6100" value="iot.jinkuncloud.com:6100" v-if="configForm.type != '01' && configForm.type != '02' && configForm.type != '03' && configForm.type != '05'"></el-option>
                  <el-option label="139.9.191.57:6100" value="139.9.191.57:6100" v-if="configForm.type != '01' && configForm.type != '02' && configForm.type != '03' && configForm.type != '05'"></el-option>
              </el-select>
          </el-form-item>
          <div v-if="configForm.type != '01' && configForm.type != '02' && configForm.type != '03' && configForm.type != '05' && configForm.type != 'GT808' ">
              <el-form-item class="row-items-3" label="定位类型：" prop="statusWorking">
                  <el-select v-model="configForm.statusWorking" placeholder="请选择定位类型">
                      <el-option label="普通定位" :value="17"></el-option>
                      <el-option label="快速定位" :value="18"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item class="row-items-3" label="普通定位周期：" prop="syncFreq" v-if="configForm.statusWorking==17">
                  <el-input type="number" v-model="configForm.syncFreq" >
                      <template slot="append">秒</template>
                  </el-input>
              </el-form-item>
              <el-form-item class="row-items-3" label="普通同步周期：" prop="locationModeFreqNormal" v-if="configForm.statusWorking==17" style="clear: both;">
                  <el-input type="number" v-model="configForm.locationModeFreqNormal" >
                      <template slot="append">秒</template>
                  </el-input>
              </el-form-item>
              <el-form-item class="row-items-3" label="快速定位周期：" prop="syncFreqFast" v-if="configForm.statusWorking==18">
                  <el-input type="number" v-model="configForm.syncFreqFast" >
                      <template slot="append">秒</template>
                  </el-input>
              </el-form-item>
              <el-form-item class="row-items-3" label="快速同步周期：" prop="locationModeFreqFast" v-if="configForm.statusWorking==18" style="clear: both;">
                  <el-input type="number" v-model="configForm.locationModeFreqFast" >
                      <template slot="append">秒</template>
                  </el-input>
              </el-form-item>
              <el-form-item class="row-items-3" label="保底同步间隔：" prop="locationModeFreqNormalMorning">
                  <el-input type="number" v-model="configForm.locationModeFreqNormalMorning" >
                      <template slot="append">秒</template>
                  </el-input>
              </el-form-item>
          </div>
          <div v-else-if="configForm.type != '01' && configForm.type != 'GT808'">
                <div v-for="(value, key) in configForm.config" :key="key">
                    <el-form-item class="row-items-1" :label="key">
                        <el-input v-model="configForm.config[key]" @blur="updateValue(key, value)"></el-input>
                    </el-form-item>
                </div>
          </div>
          <div v-if="configForm.configs != null && configForm.configs != ''">
              <el-form-item class="row-items-1 btn-form-item-c" style="text-align: right;padding-top: 10px;">
                  <el-button type="primary" size="mini" @click.native="saveConfig">保存编辑</el-button>
                  <el-button type="primary" size="mini" @click.native="cancelConfig">取消</el-button>
              </el-form-item>
          </div>
			</div>
		</el-form>

	</el-dialog>
</template>

<script>
	// 基站信息 组件
	import { checkFormat, validFormat } from "@/global/global-valid";
	import ApiGpsTag from '../../request/api-gps-tag'

	export default {
		/**
		 * @Des 组件名
		 * @Auth CC
		 * @Date 2025/09/20
		 */
		name: "GpsTagConfigDialog",
		/**
		 * @Des 组件引用
		 * @Auth CC
		 * @Date 2025/09/20
		 */
		components: {},
		props: {},
		/**
		 * @Des 数据定义
		 * @Auth CC
		 * @Date 2025/09/20
		 */
		data() {
			return {
				// 弹出层属性
				dialogForm: {
					title: "",
					dialogFormVisible: false,
					editState: 0
				},
				/**
				 * @Des 标签属性
				 * @Auth CC
				 * @Date 2025/09/20
				 */
				configForm: {
					// 状态
					status: 1,
					// 编号
					did: '',
					mac: '',
					// SIM卡信息
					iccid: '',
					imei: '',
					imsi: '',
          simPackage:'',
          simStatus:'',
          simUsed:'',
          simActivationTime:'',
          simExpirationTime:'',
          deviceStatus: '',
					// 软件版本号
					versionSoft: 0,
					// 硬件版本号
					versionHard: 0,
					// 电量
					power: 0,
					// 电压
					volt: 0,
					// 气压
					air: 0,
					// 版本号
					versionConfig: 0,
					// 定位模式 17普通定位，18快速定位
					statusWorking: 18,
					// 普通同步间隔/周期
					syncFreq: 600,
					// 快速同步间隔/周期
					syncFreqFast: 600,
					// 普通定位间隔
					locationModeFreqNormal: 300,
					// 快速定位间隔
					locationModeFreqFast: 10,
					// 保底同步间隔
					locationModeFreqNormalMorning: 1800,
					// 服务器ip
					ips: '',
					// 服务器IP
					serverIp: "",
					// 定位模式
					positionMode: '',
					// 支持的定位模式 [1,2,3]
					positionModes: '',
					// 定位组
					positionModeArray: [],
					positionModeNames: [],
					// 经度
					lngGps: 0,
					// 纬度
					latGps: 0,
                    config:{},
                    configType:{}
				},
				index: -1,
				status: {
					1: '在线',
					2: '离线'
				},
				statusWorking: {
					17: '普通定位',
					18: '快速定位'
				},
				positionModes: {
					"1": 'GPS',
					"2": 'WIFI',
					"3": 'LBS',
					"5": 'PHONE',
					"6": 'BD',
					"7": 'GN'
				},
        types: {
            '01': '电子护照',
            '02': '2A',
            '03': '蹄子',
            '05': '2G安全帽',
            '0E': '手牵手',
            '06': '测试定位标签',
            '0A': '定位标签',
            '0B': '室内外安全帽',
            '0C': '4G安全帽',
            '0F': '车载终端',
            'GT808': "GT808"
        },
				/**
				 * @Des 规则属性
				 * @Auth CC
				 * @Date 2025/09/20
				 */
				rules: {
				}
			}
		},
		created() {},
		mounted() {},
		/**
		 * @Des 方法定义
		 * @Auth CC
		 * @Date 2025/09/20
		 */
		methods: {
            updateValue(key, value){
                switch (this.configForm.configType[key]){
                    case "number":
                        this.configForm.config[key] = Number(value);
                        break;
                    case "string":
                        this.configForm.config[key] = value;
                        break;
                    case "boolean":
                        this.configForm.config[key] = Boolean(value);
                        break;
                    default:
                        this.configForm.config[key] = value;
                        break;
                }
            },
			/**
			 * @Des 打开弹出层
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			openDialog(data, index, state) {
				// console.log(data);
				this.dialogForm.title = 'GNSS标签配置项';
				// 赋值
				this.setData(data, index);
				if(state) {
					this.dialogForm.editState = state;
				}
				this.dialogForm.dialogFormVisible = true;
			},


			/**
			 * 设置值
			 * */
			setData(data, index) {
				// console.log(data);
				this.index = index;
				this.configForm = Object.assign({}, this.configForm, data);
				this.configForm.serverIp = JSON.parse(data.ips)[0]
				this.configForm.positionModeArray = JSON.parse(this.configForm.positionModes);
				this.configForm.positionModeNames = [];
				for(let mode in this.configForm.positionModeArray) {
					this.configForm.positionModeNames.push(this.positionModes[this.configForm.positionModeArray[mode]])
				}
				// 初始化
                this.configForm.config = Object.assign({}, {});
                this.configForm.configType = Object.assign({}, {});
                this.configForm.config = JSON.parse(this.configForm.configs);
                for (let key in this.configForm.config) {
                    if (this.configForm.config.hasOwnProperty(key)) {
                        this.configForm.configType[key] = typeof this.configForm.config[key];
                    }
                }
                // console.log(this.configForm.config, this.configForm.configType)
            },

			/**
			 * 编辑配置
			 * */
			editConfig() {
				this.dialogForm.editState = 1;
			},
			/**
			 * 取消配置
			 * */
			cancelConfig() {
				this.dialogForm.editState = 0;
				this.cleanValidate('configForm');
			},

			/**
			 * 保存编辑
			 * */
			saveConfig() {
			    this.configForm.configs = JSON.stringify(this.configForm.config);
                let params = {
                    dids: [this.configForm.did],
                    positionModes: this.configForm.positionModeArray,
                    ips: [this.configForm.serverIp],
                    configs: this.configForm.configs
                }
                if(this.configForm.type != '01' && this.configForm.type != '02' && this.configForm.type != '03' && this.configForm.type != '05'){
                    let param = {
                        statusWorking: this.configForm.statusWorking,
                        syncFreq: this.configForm.syncFreq,
                        syncFreqFast: this.configForm.syncFreqFast,
                        locationModeFreqNormal: this.configForm.locationModeFreqNormal,
                        locationModeFreqFast: this.configForm.locationModeFreqFast,
                        locationModeFreqNormalMorning: this.configForm.locationModeFreqNormalMorning
                    }
                    params = Object.assign({}, params, param);
                }
                // console.log(params)
                this.$request.postJsonRequest(ApiGpsTag.updateGpsTagConfigApi, params).then(result => {
                    if(result.code == 0) {
                        this.$message({
                            message: '保存成功',
                            type: 'success',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        this.$emit("searchGpsTag");
                        this.handleDialogClose();
                    } else {
                        this.$message({
                            message: result.msg,
                            type: 'error',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }
                }).catch(error => {
                    console.log("保存GNSS标签配置异常：" + this.$request.error.msg);
                })
			},

			/**
			 * @Des 弹窗关闭
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			handleDialogClose() {
				this.reset();
			},
			/**
			 * @Des 重置
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			reset() {
                this.cleanData();
                this.cleanValidate('configForm');
                this.dialogForm.dialogFormVisible = false;
            },

			/**
			 * @Des 清除表单验证
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			cleanValidate(formName) {
				// 清除表单校验的提示
				if(this.$refs[formName]) {
					// 延时执行
					this.$nextTick(function() {
						this.$refs[formName].clearValidate();
					})
				};
			},
			/**
			 * @Des 清除数据
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			cleanData() {
				// 将数据置为空
				this.configForm = Object.assign({
					// 状态
					status: 1,
					// 编号
					did: '',
					mac: '',
					// SIM卡信息
                    // SIM卡信息
                    iccid: '',
                    imei: '',
                    imsi: '',
                    simPackage:'',
                    simStatus:'',
                    simUsed:'',
                    simActivationTime:'',
                    simExpirationTime:'',
					// 软件版本号
					versionSoft: 0,
					// 硬件版本号
					versionHard: 0,
					// 电量
					power: 0,
					// 电压
					volt: 0,
					// 气压
					air: 0,
					// 版本号
					versionConfig: 0,
					// 定位模式 17普通定位，18快速定位
					statusWorking: 18,
					// 普通同步间隔/周期
					syncFreq: 600,
					// 快速同步间隔/周期
					syncFreqFast: 600,
					// 普通定位间隔
					locationModeFreqNormal: 300,
					// 快速定位间隔
					locationModeFreqFast: 10,
					// 保底同步间隔
					locationModeFreqNormalMorning: 1800,
					// 服务器ip
					ips: '',
					// 服务器IP
					serverIps: [],
					// 定位模式
					positionMode: '',
					// 支持的定位模式 [1,2,3]
					positionModes: '',
					// 定位组
					positionModeArray: [],
					positionModeNames: [],
					// 经度
					lngGps: 0,
					// 纬度
					latGps: 0
				}, {});
				// 是否编辑
				this.dialogForm.editState = 0;
				this.index = -1;
			},
		}
	}
</script>
/* JS */ /* CSS */
<style lang="scss" scoped>
	/deep/ .el-dialog {
		width: 1000px;
	}

	/deep/ .condition-form-item .el-form-item__label {
		line-height: 30px;
	}

	/deep/ .condition-form-item .el-form-item__content {
		line-height: 30px;
	}
</style>



// WEBPACK FOOTER //
// src/components_outdoor/Device/GpsTagConfigDialog.vue